//? make sure breakpoints match the values of $grid-breakpoints in variables.scss

export enum Breakpoints {
  sm = 576,
  md = 768,
  lg = 992,
  xl = 1280,
  xxl = 1440,
  xxxl = 1712,
}

export type BreakpointKeys = keyof typeof Breakpoints;
